import React from 'react';

class StickyRightButton extends React.Component {
    constructor(){
        super();
        this.state = {};
    }
    
   shouldComponentUpdate(){
       let scriptsCount = document.scripts;
       if(scriptsCount.length < 6){
        return true;
       }else{
           return false;
       }
   }
   
    loadScript = (data, type) => {
        if(type==="videocall_js"){
            let scriptString = data;
            let splittedData = typeof scriptString==="string" ? scriptString.split('<script src="'):'';
            let src = []; 
            for(let key in splittedData){
                let data = typeof splittedData[key]==="string" ? splittedData[key].split('"></script>'):'';
                src.push(data[0])
            }
            src.map(el => {               
               let script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = el;
                document.body.appendChild(script);
                return script;    
            })
        }

        if(type==="videocall_script"){            
            let scriptString = data;
            let splittedData = typeof scriptString === "string" ? scriptString.split('<script>'):'';
            let src = []; 
            for(let key in splittedData){
                let data = typeof splittedData[key]==="string" ? splittedData[key].split('</script>'):'';
                src.push(data[0])
            }

            src.map( el => {
                let scr = document.createElement('script');
                scr.type = 'text/javascript';
                scr.innerHTML = el;               
                document.body.appendChild(scr); 
                return scr;
            });
        }

    }
    render(){

        return (<div id="video-call-block" style={(this.props.videoCall.enable)?{display: "block"}:{display: "none"}}>
                <div dangerouslySetInnerHTML={{__html: this.props.videoCall.videocall_rightsticky_button}} />
                <div dangerouslySetInnerHTML={{__html: this.props.videoCall.videocall_model_html}} />
                {this.loadScript(this.props.videoCall.videocall_js, "videocall_js")}
                {this.loadScript(this.props.videoCall.videocall_script,"videocall_script")}
            </div>);     
    }
}
export default StickyRightButton;


// WEBPACK FOOTER //
// ./src/components/StickyRightButton.js